import PropTypes__default from 'prop-types';

var textStyleType = {
  target: PropTypes__default.oneOf(["Title", "Subtitle", "Description", "Image"]),
  textAlignment: PropTypes__default.oneOf(["Left", "Center", "Right"]),
  textVariant: PropTypes__default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "body1", "body2", "subtitle1", "subtitle2", "button", "caption", "overline", "infoMessage"]),
  headingStyle: PropTypes__default.oneOf(["Simple", "Green highlighted"])
};

export { textStyleType };
//# sourceMappingURL=PropShapes.js.map
